<template src="./app.html"></template>

<script>
import dmAppMixin from '../dmFramework/dmJS/dmAppMixin.js';
import dmUtils from '../dmFramework/dmJS/dmUtils.js';
import menuButton from './components/menuButton.vue';
import menuDialog from './components/menuDialog.vue';
import menuDropdown from './components/menuDropdown.vue';
import adaMixin from './js/mixins/adaMixin.js';

export default {
    name: 'app',
    mixins: [dmAppMixin, adaMixin],
    components: {
        'menu-dropdown': menuDropdown,
        'menu-dialog': menuDialog,
        'menu-button': menuButton
    },
    data() {
        return {
            districtSlug: '',
            selectedLink: null,
            showMobileLinks: false,
            isMobileDevice: false,
            showDisclaimer: true,
            hideDisclaimer: false,
            manualShowDisclaimer: false,
            initialized: false
        };
    },
    computed: {
        activeRoute() {
            return this.$route.name;
        },
        isSigninPage() {
            return this.$route.name === 'signin';
        },
        ModalsOpened() {
            return this.$store.getters['ModalModule/ModalsOpened'];
        },
        signedInUser() {
            return this.$store.state.AuthorizationModule.SignedInUser;
        },
        publicMenu() {
            return this.$store.state.PublicMenuModule.publicMenu;
        },
        announcementText() {
            return this.$store.state.PublicMenuModule.announcementText;
        }
    },
    watch: {
        selectedLink: function(newVal) {
            if(newVal) {
                this.goToLink(newVal);
            }
        }
    },
    methods: {
        toggleClick() {
            this.$refs.sidebarInstance.toggle();
        },
        goToLink(link) {
            if(!link.startsWith('http')) {
                link = 'http://' + link;
            }
            window.open(link, '_blank');
        },
        clearQuickLinks() {
            //Note : syncfusion default clear icon for dropdownlists renders as a span instead of a button
            //therefore, it is not a focusable element for screenreaders
            this.selectedLink = null;
        },
        onDisclaimerClose() {
            this.showDisclaimer = false;
            this.manualShowDisclaimer = false;
        },
        onDisclaimerCheckboxChange(e) {
            this.hideDisclaimer = e.target.checked;
        },
        onIAgreeClick() {
            if(this.hideDisclaimer) {
                dmUtils.localStorageSet(this.districtSlug + '-hideDisclaimer', "true"); 
            }
            this.showDisclaimer = false;
        },
        skipToMainContent() {
            const mainContent = document.getElementById('mainContent');
            if (mainContent) {
                mainContent.focus();
                mainContent.scrollIntoView({ behavior: 'smooth' });
            }
        }
    },
    created() {
        this.districtSlug = this.$route.params.districtSlug;
        if(this.districtSlug) {
            this.$store.dispatch('PublicMenuModule/initializeApp', this.districtSlug)
                .then(() => {
                    document.title = this.publicMenu.PublicMenuName + ' Nutrition';
                    this.initialized = true;
                });
        }

        this.isMobileDevice = window.innerWidth < 767;
        window.addEventListener('resize', () => {
            this.isMobileDevice = window.innerWidth < 767;
        });

        if (dmUtils.localStorageGet(this.districtSlug + '-hideDisclaimer') == "true") {
            this.showDisclaimer = false;
        } else {
            this.showDisclaimer = true;
        }
    },
};
</script>

<style>
@import '../node_modules/@syncfusion/ej2-icons/styles/material.css';
@import '../node_modules/@syncfusion/ej2-base/styles/material.css';
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-calendars/styles/bootstrap.css";
@import "../node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/bootstrap.css";
@import "../node_modules/@syncfusion/ej2-navigations/styles/bootstrap.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/bootstrap.css";
@import "../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap.css";
@import "../node_modules/@syncfusion/ej2-grids/styles/bootstrap.css";
@import '../node_modules/@syncfusion/ej2-lists/styles/material.css';
@import '../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css';
@import '../node_modules/@syncfusion/ej2-schedule/styles/material.css';
@import '../node_modules/@syncfusion/ej2-treegrid/styles/material.css';

.app-disclaimer-content-container {
    overflow: hidden;
    height: 100%;
    padding: 16px;
    border: 1px solid #E0E0E0;
    font-weight: 400;
    font-size: 11px;
    line-height: 160%;
    color: #8A8C90;
    margin: 8px;
    border-radius: 12px;
}

.app-disclaimer-content {
    overflow: auto;
    height: 100%;
    overscroll-behavior: contain;
}

.app-disclaimer-footer {
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.app-disclaimer-footer-checkbox {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.app-disclaimer-footer-manual {
    justify-content: flex-end;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 9px;
    border-radius: 8px;
}

::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: none;
}

::-webkit-scrollbar-thumb {
    background-color: #EEEEEF;
    border-radius: 8px;
}


input[type="checkbox"] {
    margin-right: 10px;
    height: 16px;
    width: 16px;
}

.app-mobile-quick-links {
    display: none !important;
}

@media (max-width: 576px) {
    .app-mobile-quick-links {
        display: inherit !important;
    }
}


@media (max-width: 576px) {
    .app-default-quick-links {
        display: none !important;
    }
}

@media (max-width: 991.98px) {
    .app-date-picker {
        display: none !important;
    }
    .app-tablet-date-picker {
        display: inherit !important;
    }
}


.app-footer {
    gap: 20px;   
    margin-top: 50px;
    
}

.app-footer-text {
    font-size: 14px;
    font-style: italic;
}

.app-footer-links {
    font-size: 16px;
    font-style: normal;
}
</style>
